import {
  CHANGE_SAVED_SEARCH_DIRECTORY,
  CHANGE_SAVED_SEARCH_DIRECTORY_FAILED,
  CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  CLEAR_REDIRECT_SAVED_SEARCH,
  CLEAR_SAVED_SEARCH_DIRECTORY,
  CLEAR_SAVED_SEARCH_HISTORY,
  CLEAR_SAVED_SEARCH_HISTORY_FAILED,
  CLEAR_SAVED_SEARCH_HISTORY_SUCCESS,
  CREATE_SAVED_SEARCH,
  CREATE_SAVED_SEARCH_DIRECTORY,
  CREATE_SAVED_SEARCH_DIRECTORY_FAILED,
  CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  CREATE_SAVED_SEARCH_FAILED,
  CREATE_SAVED_SEARCH_SUCCESS,
  DELETE_SAVED_SEARCH,
  DELETE_SAVED_SEARCH_DIRECTORY,
  DELETE_SAVED_SEARCH_DIRECTORY_FAILED,
  DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS,
  DELETE_SAVED_SEARCH_FAILED,
  DELETE_SAVED_SEARCH_SUCCESS,
  GET_SAVED_SEARCH,
  GET_SAVED_SEARCH_DIRECTORIES,
  GET_SAVED_SEARCH_DIRECTORIES_FAILED,
  GET_SAVED_SEARCH_DIRECTORIES_SUCCESS,
  GET_SAVED_SEARCH_DIRECTORY,
  GET_SAVED_SEARCH_DIRECTORY_FAILED,
  GET_SAVED_SEARCH_DIRECTORY_SUCCESS,
  GET_SAVED_SEARCH_FAILED,
  GET_SAVED_SEARCH_HISTORY,
  GET_SAVED_SEARCH_HISTORY_FAILED,
  GET_SAVED_SEARCH_HISTORY_SUCCESS,
  GET_SAVED_SEARCH_ID,
  GET_SAVED_SEARCH_ID_FAILED,
  GET_SAVED_SEARCH_ID_SUCCESS,
  GET_SAVED_SEARCH_RECENT,
  GET_SAVED_SEARCH_RECENT_FAILED,
  GET_SAVED_SEARCH_RECENT_SUCCESS,
  GET_SAVED_SEARCH_RESULT,
  GET_SAVED_SEARCH_RESULT_FAILED,
  GET_SAVED_SEARCH_RESULT_SUCCESS,
  GET_SAVED_SEARCH_SUCCESS,
  MOVE_SAVED_SEARCH,
  MOVE_SAVED_SEARCH_FAILED,
  MOVE_SAVED_SEARCH_SUCCESS,
  PATCH_SAVED_SEARCH,
  PATCH_SAVED_SEARCH_FAILED,
  PATCH_SAVED_SEARCH_SUCCESS,
  SET_REDIRECT_SAVED_SEARCH,
} from 'redux/constants/savedSearchConstants';
import { SAVED_SEARCH_PAGE_SIZE } from 'redux/sagas/savedSearchSaga';
import { ActionType } from 'types/reduxTypes';
import {
  SavedSearchDirectoryResultType,
  SavedSearchDirectoryType,
  SavedSearchItemType,
  SavedSearchRequestSuccessType,
  SavedSearchResultType,
  SavedSearchStoreType,
} from 'types/savedSearchType';

const initialState: SavedSearchStoreType = {
  directories: [],
  error: false,
  errorText: '',
  hasMore: true,
  loading: false,
  savedSearchHistory: [],
  savedSearchList: [],
  savedSearchListPage: 1,
  savedSearchRecentList: [],
};

export default (state = initialState, action: ActionType<unknown>): typeof initialState => {
  switch (action.type) {
    case GET_SAVED_SEARCH: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_SUCCESS: {
      const { data: savedSearchList, page } = action.payload as SavedSearchRequestSuccessType;
      const newList = page === 1 ? savedSearchList : state.savedSearchList.concat(savedSearchList);
      return {
        ...state,
        hasMore: savedSearchList.length === SAVED_SEARCH_PAGE_SIZE,
        loading: false,
        savedSearchList: newList,
      };
    }
    case GET_SAVED_SEARCH_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case CREATE_SAVED_SEARCH: {
      return { ...state, loading: true };
    }
    case CREATE_SAVED_SEARCH_SUCCESS: {
      return { ...state, loading: false };
    }
    case CREATE_SAVED_SEARCH_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    // ------- get recent ------- //

    case GET_SAVED_SEARCH_RECENT: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_RECENT_SUCCESS: {
      const { data: savedSearchRecentList } = action.payload as SavedSearchRequestSuccessType;
      return {
        ...state,
        hasMore: false,
        loading: false,
        savedSearchRecentList,
      };
    }
    case GET_SAVED_SEARCH_RECENT_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    // ------- get history ------- //

    case GET_SAVED_SEARCH_HISTORY: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_HISTORY_SUCCESS: {
      const { data: savedSearchHistory, page } = action.payload as SavedSearchRequestSuccessType;
      const newList = page === 1 ? savedSearchHistory : state.savedSearchList.concat(savedSearchHistory);
      return {
        ...state,
        hasMore: savedSearchHistory.length === SAVED_SEARCH_PAGE_SIZE,
        loading: false,
        savedSearchHistory: newList,
      };
    }
    case GET_SAVED_SEARCH_HISTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case GET_SAVED_SEARCH_ID: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_ID_SUCCESS: {
      const savedSearchItem = action.payload as SavedSearchItemType;
      return { ...state, loading: false, savedSearchItem };
    }
    case GET_SAVED_SEARCH_ID_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case DELETE_SAVED_SEARCH: {
      return { ...state, loading: true };
    }
    case DELETE_SAVED_SEARCH_SUCCESS: {
      const id = action.payload as string;
      const { savedSearchList } = state;
      const newList = savedSearchList.filter((x) => x.id !== id);
      return { ...state, loading: false, savedSearchList: newList };
    }
    case DELETE_SAVED_SEARCH_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case PATCH_SAVED_SEARCH: {
      return { ...state, loading: true };
    }
    case PATCH_SAVED_SEARCH_SUCCESS: {
      return { ...state, loading: false };
    }
    case PATCH_SAVED_SEARCH_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case MOVE_SAVED_SEARCH: {
      return { ...state, loading: true };
    }
    case MOVE_SAVED_SEARCH_SUCCESS: {
      const id = action.payload as string;
      const { savedSearchList } = state;
      const newList = savedSearchList.filter((x) => x.id !== id);
      return { ...state, loading: false, savedSearchList: newList };
    }
    case MOVE_SAVED_SEARCH_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case GET_SAVED_SEARCH_RESULT: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_RESULT_SUCCESS: {
      const data = action.payload as SavedSearchResultType[];
      return { ...state, loading: false, savedSearchResults: data };
    }
    case GET_SAVED_SEARCH_RESULT_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    /// -- directory --

    case CREATE_SAVED_SEARCH_DIRECTORY: {
      return { ...state, loading: true };
    }
    case CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS: {
      const { directories } = state;
      const directory = action.payload as SavedSearchDirectoryType;
      const newDirectories = [directory, ...directories];
      return { ...state, directories: newDirectories, loading: false };
    }
    case CREATE_SAVED_SEARCH_DIRECTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case GET_SAVED_SEARCH_DIRECTORY: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_DIRECTORY_SUCCESS: {
      const directory = action.payload as SavedSearchDirectoryType;
      return { ...state, currentDirectory: directory, loading: false };
    }
    case GET_SAVED_SEARCH_DIRECTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case GET_SAVED_SEARCH_DIRECTORIES: {
      return { ...state, loading: true };
    }
    case GET_SAVED_SEARCH_DIRECTORIES_SUCCESS: {
      const { directories } = action.payload as SavedSearchDirectoryResultType;
      return { ...state, directories: directories, loading: false };
    }
    case GET_SAVED_SEARCH_DIRECTORIES_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case CHANGE_SAVED_SEARCH_DIRECTORY: {
      return { ...state, loading: true };
    }
    case CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS: {
      return { ...state, loading: false };
    }
    case CHANGE_SAVED_SEARCH_DIRECTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case DELETE_SAVED_SEARCH_DIRECTORY: {
      return { ...state, loading: true };
    }
    case DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS: {
      const id = action.payload as string;
      const { directories } = state;
      const newDirectories = directories.filter((x) => x.id !== id);
      return { ...state, directories: newDirectories, loading: false };
    }
    case DELETE_SAVED_SEARCH_DIRECTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case SET_REDIRECT_SAVED_SEARCH: {
      return { ...state, redirect: true };
    }
    case CLEAR_REDIRECT_SAVED_SEARCH: {
      return { ...state, redirect: false };
    }

    case CLEAR_SAVED_SEARCH_HISTORY: {
      return { ...state, loading: true };
    }
    case CLEAR_SAVED_SEARCH_HISTORY_SUCCESS: {
      return { ...state, loading: false };
    }
    case CLEAR_SAVED_SEARCH_HISTORY_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case CLEAR_SAVED_SEARCH_DIRECTORY: {
      return { ...state, currentDirectory: undefined };
    }

    default: {
      return state;
    }
  }
};
